import type { TypedUseQuerySubscriptionOptions } from '@reduxjs/toolkit/query/react';
import useDevicesManager from './useDevicesManager';
import { useMemo } from 'react';

type Options = TypedUseQuerySubscriptionOptions;

function useDevicesByCommanderManager(
  args: { storeId: string; commanderId: string },
  options: Options = {}
) {
  const { storeId, commanderId } = args;
  const responseDevicesAPI = useDevicesManager(storeId, options);
  const { data: devices } = responseDevicesAPI;
  const data = useMemo(
    () =>
      devices?.filter(
        (device) =>
          device.commanderId === commanderId && device.composableDevice
      ),
    [commanderId, devices]
  );

  return {
    ...responseDevicesAPI,
    data,
  };
}

export default useDevicesByCommanderManager;
